/** Типы страницы «Индекс цен» (Ценообразование → Индекс цен). */

export type PriceIndexCheckStatus =
  | 'unchecked'
  | 'ok'
  | 'different_product'
  | 'my_price_mismatch'
  | 'analog_price_mismatch'
  | 'link_dead'
  | 'manual_review'
  | 'not_found'

export type PriceIndexAnalogSource = 'wb' | 'ozon' | 'external'

export interface PriceIndexItem {
  id: number
  user_id: number
  nm_id: string
  vendor_code?: string
  db_vendor_code?: string
  product_id?: string
  seller_id?: number
  design_code?: string
  photo_url?: string
  brand?: string
  category?: string
  file_my_price?: number
  file_analog_price?: number
  file_index?: string
  my_url?: string
  analog_url?: string
  analog_source: PriceIndexAnalogSource
  analog_nm_id?: string
  analog_is_ours: number
  analog_vendor_code?: string
  analog_seller_id?: number
  analog_design_code?: string
  analog_photo_url?: string
  check_status: PriceIndexCheckStatus
  check_comment?: string
  actual_my_price?: number
  actual_analog_price?: number
  cabinet_price?: number
  spp?: number
  spp_category_prefix?: string
  spp_price_from?: number
  spp_price_to?: number
  spp_sample_count?: number
  spp_confidence?: 'low' | 'medium' | 'high'
  spp_calculated_at?: string
  checked_at?: string
  new_price?: number
  new_discount: number
  new_price_spp?: number
  pushed_at?: string
  created_at: string
  updated_at: string
}

/** Подписи и цвета статусов проверки. Badge variants дизайн-системы. */
export const CHECK_STATUS_META: Record<
  PriceIndexCheckStatus,
  { label: string; badge: 'gray' | 'red' | 'yellow' | 'green' | 'blue' | 'indigo' | 'purple'; dotClass: string }
> = {
  unchecked: { label: 'Не проверен', badge: 'gray', dotClass: 'bg-gray-400' },
  ok: { label: 'Товар идентичен', badge: 'green', dotClass: 'bg-green-500' },
  different_product: { label: 'Товар отличается', badge: 'red', dotClass: 'bg-red-500' },
  my_price_mismatch: { label: 'Неверная цена моего товара', badge: 'yellow', dotClass: 'bg-yellow-500' },
  analog_price_mismatch: { label: 'Неверная цена идентичного товара', badge: 'yellow', dotClass: 'bg-amber-500' },
  link_dead: { label: 'Ссылка не открывается', badge: 'red', dotClass: 'bg-rose-500' },
  manual_review: { label: 'Ручная проверка', badge: 'blue', dotClass: 'bg-blue-500' },
  not_found: { label: 'Не найден в базе', badge: 'gray', dotClass: 'bg-zinc-400' },
}

/**
 * Подписи достоверности расчёта СПП.
 *
 * Само значение (`low` / `medium` / `high`) считается по размеру выборки
 * наблюдений: показывать его как есть — значит просить оператора помнить
 * английский перечень.
 */
export const SPP_CONFIDENCE_LABELS: Record<string, string> = {
  low: 'низкая',
  medium: 'средняя',
  high: 'высокая',
}

/** «450 ₽» — пробел-разделитель тысяч, как принято в дизайн-системе. */
export function fmtPrice(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—'
  const num = Number(value)
  if (!Number.isFinite(num)) return '—'
  return `${num.toLocaleString('ru-RU', { maximumFractionDigits: 2 })} ₽`
}
